import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { DataError } from './data-client.js';
const DataClientContext = createContext(null);
export function createQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30_000,
                // Ошибки доступа и валидации повторять бессмысленно.
                retry: (count, error) => count < 1 && !(error instanceof DataError && error.status >= 400 && error.status < 500),
            },
        },
    });
}
export function DataProvider({ client, queryClient, children, }) {
    return (_jsx(DataClientContext.Provider, { value: client, children: _jsx(QueryClientProvider, { client: queryClient, children: children }) }));
}
export function useDataClient() {
    const client = useContext(DataClientContext);
    if (!client)
        throw new Error('useDataClient: нет <DataProvider> выше по дереву');
    return client;
}
//# sourceMappingURL=provider.js.map